import { render, staticRenderFns } from "./selCar.vue?vue&type=template&id=36a17bf1&scoped=true&"
import script from "./selCar.vue?vue&type=script&lang=js&"
export * from "./selCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a17bf1",
  null
  
)

export default component.exports